export default __webpack_public_path__ + "static/media/marker-icon.40e1612f.svg";